import { mapGetters } from 'vuex'

export default function useFeature (featureName) {
  const mixin = {
    computed: {
      ...mapGetters('feature', {
        isFeatureActive: 'isActive'
      })
    }
  }

  mixin.computed[featureName] = function () {
    return this.isFeatureActive(featureName)
  }

  return mixin
}
